<div class="container-fluid">

  <h4 id="upper"> Coopératives </h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>

            <a (click)="openModal()" title="Cliquez ici pour ajouter un certificat de decès"
              style="background-color:#578D63 ;" href="javascript:void(0);" class="btn btn-success mb-2" id="gras">
              <i class="mdi mdi-plus me-2"></i> Ajouter
            </a>&nbsp;
          </div>

          <div class="row mb-md-2">


            <!-- End search -->
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col" class="ps-0">Nom coopérative</th>
                  <th scope="col">Localisation</th>
                  <th scope="col" class="text-center">Longitude</th>
                  <th scope="col" class="text-center">Latitude</th>
                  <th scope="col" class="text-center">Description</th>
                  <th scope="col" colspan="2" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item  of paginatedItems">
                  <th scope="row" class="ps-0 fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.nom}} &nbsp;
                    </span>
                  </th>
                  <td>
                    <span class="table-link1 text-truncate d-block">{{item.localisation}}</span>
                  </td>

                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.longitude }}&nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.latitude}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.description}}&nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">

                    <a (click)="addAdministrateurToCooperative(item)" title="" style="cursor: pointer;" 
                    class="me-3 text-primary" v-b-tooltip.hover 
                    title="Cliquez ici pour ajouter un administrateur à une coopérative">
                   <i class="mdi mdi-account-plus font-size-18"></i>
                 </a>
                 
                    <a (click)="editOpenModal(item)" title="" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="Cliquez ici pour modifier une coopérative">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmSuppression(item)" title="Cliquez ici pour supprimer une coopérative"
                      href="javascript:void(0);" class="text-danger" v-b-tooltip.hover
                      title="Cliquez ici pour retirer administrateurs">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a> &nbsp;&nbsp;

                  </td>

                </tr>

              </tbody>
            </table>
          </div>

        </div>
        <div class="d-flex justify-content-center mt-4" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours...</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Message d'erreur -->
        <div *ngIf="hasError && !isLoading" class="text-center my-5">
          <i class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i>
          <p class="text-danger">{{ errorMessage }}</p>
          <button class="btn btn-primary" (click)="getCooperative()"><i class="pi pi-refresh"
              style="font-size: 2rem"></i>
          </button>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center mt-4">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>


</div>
<p-toast position="top-center" />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>


<p-dialog header="Administrateur coopérative" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
  <div class="d-flex flex-column align-items-center">
    <div class="col-12 col-md-8 text-center">
      <label for="admin_id" class="form-label">Administrateur</label>
      <select name="admin_id" [(ngModel)]="selectedAdmin" class="form-select" id="admin_id">
        <option *ngFor="let item of adminItems" [value]="item.reference">{{ item.nom }}</option>
      </select>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="Enregistrer" (click)="saveAdminToCooperative()" />
  </div>
</p-dialog>
